import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-confirm-popup',
    templateUrl: './confirm-popup.component.html',
    styleUrls: [
        './confirm-popup.styl'
    ]
})
export class ConfirmPopupComponent {
    public confirmData: any;

    constructor(
        private activeModal: NgbActiveModal,
    ) {
    }

    ok() {
        this.activeModal.close('OK');
    }

    cancel() {
        this.activeModal.dismiss('Cancel');
    }
}
